import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { SymptomMatrix } from '../components/SymptomMatrix';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { PriceBlock } from '../components/PriceBlock';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#faf8f0] font-sans text-[#1a3c2a]" data-id="element-234">
      <HeroSection data-id="element-235" />
      <OpeningHook data-id="element-236" />
      <ProblemSection data-id="element-237" />
      <FailedSolutions data-id="element-238" />
      <SymptomMatrix data-id="element-239" />
      <WhatYouGet data-id="element-240" />
      <WhoIsFor data-id="element-241" />
      <HowItWorks data-id="element-242" />
      <Testimonials data-id="element-243" />
      <FAQ data-id="element-244" />
      <PriceBlock data-id="element-245" />
      <Footer data-id="element-246" />
    </div>;
}